export default function FutureTense() {
  return (
    <table className="table_sticky">
      <tbody>
        <tr>
          <th>
            <em>infinitive</em>
          </th>
          <td> dělati </td>
        </tr>
        <tr>
          <th> ja </th>
          <td> budu dělati </td>
        </tr>
        <tr>
          <th> ty </th>
          <td> budeš dělati </td>
        </tr>
        <tr>
          <th> on/ona/ono </th>
          <td> bude dělati </td>
        </tr>
        <tr>
          <th> my </th>
          <td> budemo dělati </td>
        </tr>
        <tr>
          <th> vy </th>
          <td> budete dělati </td>
        </tr>
        <tr>
          <th> oni/one </th>
          <td> budut dělati </td>
        </tr>
      </tbody>
    </table>
  )
}
